import React, { Component } from "react";
import { observer } from "mobx-react";
import { Router } from "@reach/router";
import { css, cx } from "react-emotion";

import theme from "components/theme";

import DefaultLayout from "../DefaultLayout";
import AuthFormLogin from "./AuthFormLogin";
import AuthFormPasswordReset from "./AuthFormPasswordReset";
import AuthFormPasswordResetSent from "./AuthFormPasswordResetSent";
import AuthFormPasswordNew from "./AuthFormPasswordNew";
import AuthFormPasswordNewSaved from "./AuthFormPasswordNewSaved";

class PageAuthLogin extends Component {
  render() {
    const { className } = this.props;
    const { styles } = this;

    return (
      <DefaultLayout logoLink="/" triggerPageView footerContentLight footerHideOnMobile ignoreFooterMargins>
        <div className={cx([className, styles.root])}>
          <div className="_box vhcenter">
            <div className="bg-wrapper">
              <div className="wrapper">
                <Router>
                  <AuthFormLogin path={`/`} />
                  <AuthFormPasswordReset path={`forgot`} />
                  <AuthFormPasswordResetSent path={`forgot/sent`} />
                  <AuthFormPasswordNew path={`new-password`} />
                  <AuthFormPasswordNewSaved path={`new-password/saved`} />
                </Router>
              </div>
            </div>
          </div>
          <img
            src={
              "https://images.ctfassets.net/ge8keufw4e75/4NUe0wJDMAS2SwgggW4GO6/1bb6659dc7885414615f8f254b6d6ecd/admin-console-bg.jpg?w=3000"
            }
            alt=""
            title=""
          />
        </div>
      </DefaultLayout>
    );
  }

  styles = {
    root: css`
      display: flex;
      min-height: 600px;
      height: 500px; /* smaller than min-height = IE 11 fix */
      max-height: calc(100vh - 65px - 150px);
      @media (max-width: ${theme.limits.minWidth}) {
        max-height: calc(100vh - 55px);
      }
      img {
        object-fit: cover;
        max-width: 100%;
        width: 100%;
      }

      ._box {
        background: ${theme.colors.primaryInverse};
        border-radius: 10px;
        width: 90%;
        max-width: 350px;
      }

      ._inputs {
        margin-top: 20px;
        margin-bottom: 30px;
        display: inline-block;
        min-width: 300px;
        position: relative;
      }
      .wrapper {
        padding: 25px 30px 30px 30px;
        background-color: ${theme.colors.primaryInverse};
        border-radius: 10px;
      }
      .bg-wrapper {
        padding-top: 5px;
        background-color: ${theme.colors.primary};
        border-radius: 10px;
      }
    `,
  };
}

PageAuthLogin = observer(PageAuthLogin);

export default PageAuthLogin;
